<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="wordType" style="overflow-y: auto;">
        <div class="backBox">
          <button class="btn btn-back" @click="examHide">返回</button>
        </div>
        <div class="content-item" v-for="(item,index) in wordList.practice" :key="index"  v-loading="loading" :element-loading-text="loadTxt">
          <div class="write-txt">
            <p class="title">题目{{(index+1)}}</p>
            <button class="btn btn-topic-remove" v-if="index>0" @click="examRemove(index)">删除</button>
            <!-- <button class="btn btn-topic-ai" @click="aiTopic(item)">AI出题</button> -->
          </div>
          <div class="write-txt">
            <p class="write-title">选择词义：<span>*</span></p>
            <div class="write-text">
              <el-select v-model="item.sense" placeholder="请选择">
                <el-option
                  v-for="item in wordList.senses"
                  :key="item.sense"
                  :label="item.sense"
                  :value="item.sense"
                >
                </el-option>
              </el-select>
              <button class="btn btn-topic-ai" @click="aiTopic(item)">AI出题</button>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">题干：<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="item.topic_title"></textarea>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">选项：<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="item.option"></textarea>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">答案：<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="item.answer"></textarea>
            </div>
          </div>
        </div>
        <button class="btn btn-add" @click="addTopic">+添加题目</button>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="topicSub">保存</button>
          <button class="btn btn-close" @click="examHide">取消</button>
        </div>
      </div>

      <div class="MobelBox" v-else-if="addType" v-loading="loading" :element-loading-text="loadTxt">
        <div class="" style="display: block;height: 100%;overflow-y: auto;">
          <div class="content-item">
            <div class="write-txt">
              <p class="write-title">古诗名：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.name"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">作者：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.author"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">背景介绍：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.introduce"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">上传音频：<span>*</span></p>
              <div class="write-text">
                <div class="img" v-if="addObj.audio" style="width: 300px;">
                  <audio controls :src="'https://pic.speechcoach.cn/'+addObj.audio"></audio>
                </div>
                <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj"
                  list-type="picture-card"
                  :before-upload="beforeUploadImg"
                  :on-success="(response, file, fileList)=>{return handleSuccessAudio(response, file, fileList)}"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveImg"
                  accept="audio/*"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div> 
             
            <div class="wordList">
              <div class="word-item" v-for="(item,index) in addObj.sentence" :key="index">
                <div class="write-txt">
                  <p class="write-title">古诗句{{(index+1)}}：<span>*</span></p>
                  <div class="write-text poetry-txt">
                    <button class="btn btn-poetry-add" @click="addSentence(item)">+添加古诗句</button>
                    <button class="btn btn-poetry-remove" @click="removeSentence(item,index)" v-if="index>0">删除</button>
                  </div>
                  <div class="write-text poetry-txt" style="padding: 20px 100px ;">
                    <div class="write-text-poetry" v-for="(ele,num) in item.sentence" :key="num">
                      <textarea placeholder="" v-model="ele.sentence" @input="numCheck(ele,128,'sentence')"></textarea>
                      <el-checkbox v-model="ele.is_hide">备考隐藏</el-checkbox>
                      <button class="btn btn-poetry-txt-remove" @click="poetryRemove(item,num)" v-if="num>0">删除</button>
                    </div>
                    <button class="btn btn-poetry-txt-add" @click="poetryAdd(item)">添加</button>
                  </div>
                </div>

                <div class="write-txt">
                  <p class="write-title">古诗句拼音{{(index+1)}}：<span>*</span></p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.pinyin"></textarea>
                  </div>
                </div>

                <div class="write-txt">
                  <p class="write-title">译文{{(index+1)}}：<span>*</span></p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.translation"></textarea>
                  </div>
                </div>

                <div class="write-txt">
                  <p class="write-title">上传图片{{(index+1)}}：<span>*</span></p>
                  <div class="write-text">
                    <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="item.image">
                      <img :src="'https://pic.speechcoach.cn/'+item.image" alt="">
                      <div class="hover" v-if="imgType">
                        <i class="icon-delete" @click="imgRemove"></i>
                      </div>
                    </div>
                    <el-upload
                      :action="'https://upload.qiniup.com'"
                      :data="uploadObj"
                      list-type="picture-card"
                      :before-upload="beforeUploadImg"
                      :on-success="(response, file, fileList)=>{return handleSuccessImgSentence(response, file, fileList,index,item,'sentence')}"
                      :on-progress="handleProgressImg"
                      :on-remove="handleRemoveImg"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img
                        width="100%"
                        :src="'https://pic.speechcoach.cn/' + item.image"
                        alt=""
                      />
                    </el-dialog>
                  </div>
                </div> 

                <div class="keywords" v-for="(ele,num) in item.keywords" :key="num">
                  <div class="write-txt">
                    <p class="write-title">关键字词{{(num+1)}}：</p>
                    <div class="write-text">
                      <textarea placeholder="" v-model="ele.keyword"></textarea>
                      <button class="btn btn-keywords-add" @click="addKeywords(item)">+添加关键词注释</button>
                      <button class="btn btn-keywords-remove" @click="removeKeywords(item,num)">删除</button>
                    </div>
                  </div>
                  <div class="write-txt">
                    <p class="write-title">注释{{(num+1)}}：</p>
                    <div class="write-text">
                      <textarea placeholder="" v-model="ele.annotation"></textarea>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            
          </div>

          <div class="write-btnBox">
            <button class="btn btn-save" @click="saveSub">保存</button>
            <button class="btn btn-close" @click="closeSub">取消</button>
          </div>
        </div>
      </div>
      
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <p>添加古诗词</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.author">{{item.author}}</p>
              <p :title="item.sort">{{item.sort}}</p>
              <p :title="item.add_time">{{item.create_time}}</p>
              <p class="btnList">
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <button title="删除" style="color: #FF1919;" class="btn btn-remove" @click="removeShow(item)">删除</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      <div class="msgBox" v-if="removeType">
        <div class="contv">
          <p class="title">是否确定删除？</p>
          <div class="btnBox">
            <button class="btn btn-close" @click="removeHide">取消</button>
            <button class="btn btn-sub" @click="removeSub">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPoemList,getLibraryDetail,getUploadToken ,aiSetQuestions ,getPoemDetail ,savePoem,delPoem} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'ID'},
        {id:2,title:'古诗名'},
        {id:3,title:'作者'},
        {id:4,title:'排序'},
        {id:5,title:'添加时间'},
        {id:6,title:'操作'},
      ],
      dataList:[
      ],
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        lid:'',
        name:'',
        author:'',
        introduce:'',
        audio:'',
        sentence:[
          {sentence:[{num:1,sentence:'',is_hide:false}],translation:'',image:'',keywords:[{keyword:'',annotation:''}]}
        ],
      },
      totalPage:0,
      url:'',
      reviewType:false,
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      queryObj:{
        type:'',
        id:'',
      },
      wordType:false,
      wordList:[],
      senseList:[],
      questionsObj:{
        name:'',
        sense:'',
      },
      wordIndex:'',
      loadTxt:'',
      loading:false,
      addType:'',
      removeType:false,
      removeID:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.queryObj = {
      type:this.$route.query.type,
      id:this.$route.query.id,
    };
    // this.getDetail();
    this.obj.lid = this.$route.query.lid;
    this.addObj.lid = this.$route.query.lid;
    this.getToken();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.obj,this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token;   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getList(){
      var that = this;
      try {
        const response = await getPoemList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.status==0){
              item.status=false
            } else {
              item.status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getDetail(){
      var that = this;
      try {
        const response = await getLibraryDetail({id:this.queryObj.id,from_type:2},this.token);
        if(response.code == 200){
          if(that.queryObj.type == 1){
            if(response.data.words && response.data.words.length > 0){
              response.data.words.forEach(function(item,index){
                item.practice.forEach(function(ele,num){
                  ele.option = 'A.' + ele.option_A + '\rB.' + ele.option_B + '\rC.' + ele.option_C + '\rD.' + ele.option_D
                });
              })
              that.addObj.words = response.data.words;
            } else {
              that.addObj.words = [
                {name:'',mnemonic:'',image:'',
                  senses:[
                    {sense:'',example:'',keyword:''}
                  ],
                  practice:[
                    {
                      sense:'',
                      topic_title:'',
                      option:'',
                      answer:''
                    }
                  ]
                }
              ]
            };
          } else {
            if(response.data.poems&&response.data.poems.length==0){
              that.addObj.poems = [
                {name:'',author:'',introduce:'',audio:'',
                  sentence:[
                    {sentence:[{num:1,sentence:'',is_hide:false}],translation:'',image:'',keywords:[{keyword:'',annotation:''}]}
                  ],
                }
              ]
            } else {
              that.addObj.poems = response.data.poems;
            }
          };
          that.$forceUpdate();
          console.log(that.addObj.poems)
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getPoemDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addType = 'edit';
          that.addObj = response.data;
          response.data.sentence.forEach(function(item,index){
            item.sentence.forEach(function(ele,num){
              if(ele.is_hide==1){
                ele.is_hide = true
              } else {
                ele.is_hide = false
              }
            })
          })
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    async saveSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请填写古诗名');
        return false;
      }
      if(this.addObj.author == ''){
        that.$message('请填写作者');
        return false;
      }
      if(this.addObj.introduce == ''){
        that.$message('请填写介绍');
        return false;
      }
      if(this.addObj.audio == ''){
        that.$message('请上传录音');
        return false;
      }
      try {
        this.addObj.sentence.forEach(function(item,index){
          if(item.sentence == ''){
            that.$message('请填写古诗句'+(index+1)+'名称');
            throw new Error("EndIterative");
          }
          if(item.pinyin == ''){
            that.$message('请填写古诗句'+(index+1)+'拼音');
            throw new Error("EndIterative");
          }
          if(item.translation == ''){
            that.$message('请填写古诗句'+(index+1)+'译文');
            throw new Error("EndIterative");
          }
          if(item.image == ''){
            that.$message('请上传古诗句'+(index+1)+'图片');
            throw new Error("EndIterative");
          }
         
        });
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      this.addObj.sentence.forEach(function(item,index){
        item.sentence.forEach(function(ele,num){
          if(ele.is_hide){
            ele.is_hide = 1
          } else {
            ele.is_hide = 0
          }
        })
      })
      try {
        const response = await savePoem(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delPoem({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.removeID = '';
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

     removeHide(){
      var that = this;
      that.removeType = false;
      that.removeID = '';
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        lid:'',
        name:'',
        author:'',
        introduce:'',
        audio:'',
        sentence:[
          {sentence:[{num:1,sentence:'',is_hide:false}],translation:'',image:'',keywords:[{keyword:'',annotation:''}]}
        ],
      };
      this.addObj.lid = this.$route.query.lid;
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.loading = false;
        that.getList();
      } else {
        that.$message(response.msg);
      }
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    handleSuccessImg(response, file, fileList,index,e,type) {
      var that = this;
      this.addObj.words[index].image = response.key;
      that.$forceUpdate();
      that.loading = false;
      that.uploadObj.key = "";
    },

     handleSuccessImgSentence(response, file, fileList,index,e,type) {
      var that = this;
      e.image = response.key;
      that.$forceUpdate();
      that.loading = false;
      that.uploadObj.key = "";
    },

    handleSuccessAudio(response, file, fileList){
      var that = this;
      this.addObj.audio = response.key;
      that.$forceUpdate();
      that.loading = false;
      that.uploadObj.key = "";
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
      that.uploadObj.key = "";
    },

     beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    addWord(e){
      e.senses.push(
        {sense:'',example:'',keyword:''}
      );
      this.$forceUpdate();
    },

    removeWord(e,index){
      e.senses.splice(index,1);
      this.$forceUpdate();
    },

    examShow(e,index){
      this.wordType = true;
      this.wordList = JSON.parse(JSON.stringify(e));
      this.wordIndex = index;
      console.log(e)
    },
    
    examHide(){
      this.wordType = false;
      this.wordList = [];
    },

    examRemove(index){
      this.wordList.practice.splice(index,1);
    },

    addTopic(){
      this.wordList.practice.push(
        {
          sense:'',
          topic_title:'',
          option:'',
          answer:''
        }
      )
    },

    addRecite(){
      this.addObj.words.push(
        {name:'',mnemonic:'',image:'',
          senses:[
            {sense:'',example:'',keyword:''}
          ],
          practice:[
            {
              sense:'',
              topic_title:'',
              option:'',
              answer:''
            }
          ]
        }
      );
      this.$forceUpdate();
    },

    removeRecite(index){
      this.addObj.words.splice(index,1);
      this.$forceUpdate();
    },

    reviewShow(){
      this.reviewType = true;
    },

    async aiTopic(e){
      console.log(e)
      var that = this;
      this.loadTxt = 'AI出题中，请稍后';
      this.loading = true;
      this.questionsObj = {
        name : this.wordList.name,
        sense : e.sense
      }
      try {
        const response = await aiSetQuestions(this.questionsObj,this.token);
        if(response.code == 200){
            e.answer = response.data.topic.answer;
            e.topic_title = response.data.topic.topic;
            e.option = 'A.' + response.data.topic.option_A + '\rB.' + response.data.topic.option_B + '\rC.' + response.data.topic.option_C + '\rD.' + response.data.topic.option_D
            that.loadTxt = '';
            that.loading = false;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    topicSub(){
      var that = this;
      try {
        this.wordList.practice.forEach(function(item,index){
          if(item.sense == ''){
            that.$message('请选择题目'+(index+1)+'词义');
            throw new Error("EndIterative");
          }
          if(item.topic_title == ''){
            that.$message('请填写题目'+(index+1)+'题干');
            throw new Error("EndIterative");
          }
          if(item.option == ''){
            that.$message('请填写题目'+(index+1)+'选项');
            throw new Error("EndIterative");
          }
          if(item.answer == ''){
            that.$message('请填写题目'+(index+1)+'答案');
            throw new Error("EndIterative");
          }
        });
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      this.addObj.words[this.wordIndex].practice = this.wordList.practice;
      this.wordType = false;
    },


    addPoetry(){
      var that = this;
      var list = {name:'',author:'',introduce:'',
        sentence:[
          {sentence:[{num:1,sentence:'',is_hide:false}],translation:'',image:'',keywords:[{keyword:'',annotation:''}]}
        ],
      }
      that.addObj.poems.push(list);
      this.$forceUpdate();
    },

    removePoetry(index){
      this.addObj.poems.splice(index,1);
      this.$forceUpdate();
    },

    addSentence(e){
      this.addObj.sentence.push(
        {
          sentence:[{num:1,sentence:'',is_hide:false}],
          translation:'',
          image:'',
          keywords:[
            {keyword:'',annotation:''}
          ]
        }
      )
      this.$forceUpdate();
    },

    removeSentence(e,i){
      this.addObj.sentence.splice(i,1);
      this.$forceUpdate();
    },

    poetryAdd(e,num){
      e.sentence.push({num:e.sentence.length+1,sentence:'',is_hide:false});
    },

    poetryRemove(e,num){
      e.sentence.splice(num,1);
    },

    addKeywords(e){
      e.keywords.push({keyword:'',annotation:''});
      this.$forceUpdate();
    },

    removeKeywords(e,i){
      e.keywords.splice(i,1);
      this.$forceUpdate();
    },

    
    numCheck(ele,i,type){
      var that = this;
      var num = ele.sentence;
      num = num.length;
      if(num > i){
          if(type == 'sentence'){
              ele.sentence = ele.sentence.slice(0,i);
              that.$forceUpdate();
              that.$message('已超出128个字数');
            return false;
          }
      }
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 6 );
  }

  .dataList .listItem p .btn{
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
    height: calc( 100% - 120px );
    overflow: hidden;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
    position: relative;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox .write-text .btn-word-remove{
    color: #fff;
    font-size: 18px;
    background-color: #F26060;
    border-radius: 6px;
    height: 36px;
    line-height: 36px;
    margin-left: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 36px;
    position: absolute;
    right: 0;
    top: 0;
  }

  .MobelBox .write-text .btn{
    color: #fff;
    font-size: 18px;
    background-color: #F26060;
    border-radius: 6px;
    height: 36px;
    line-height: 36px;
    margin-left: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 36px;
  }

  .MobelBox .write-text .btn.btn-keywords-add,
  .MobelBox .write-text .btn.btn-poetry-add{
      background-color: transparent;
      border: solid 1px #00C7A3;
      color: #00C7A3;
  }

  .MobelBox .write-text .write-text-poetry{
    font-size: 0;
    margin-top: 20px;
  }

  .MobelBox .write-text .write-text-poetry textarea,
  .MobelBox .write-text .write-text-poetry .btn-poetry-txt-add{
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
  }

  .MobelBox .write-text .write-text-poetry textarea{
    height: 90px;
  }

  .MobelBox .write-text .btn-poetry-txt-add{
    display: block;
    background-color: #00C7A3;
    border-radius: 6px;
    color: #fff;
    padding: 0px 35px;
    box-sizing: border-box;
    margin: 20px 0 0 0;
  }

  .MobelBox .write-text .write-text-poetry>>> .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #333333;
  }

  .MobelBox .write-text .write-text-poetry>>> .el-checkbox__inner:hover{
    border-color: #00C7A3;
  }

  .MobelBox .write-text .write-text-poetry>>> .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #00C7A3;
    border-color: #00C7A3;
  }

  .MobelBox .write-text .btn.btn-keywords-remove,
  .MobelBox .write-text .btn.btn-poetry-remove{
    left: 800px;
    top: 0;
  }

  .MobelBox .write-text .btn.btn-keywords-remove{
    left: 850px;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 550px;
    height: 330px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .MobelBox .poetry-txt textarea{
    /* width: 550px;
    height: 330px; */
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .write-btnBox .btn{
    width: 145px;
    height: 51px;
    line-height: 51px;
    border-radius: 8px;
    color: #fff;
    background-color: #00C7A3;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 80px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .msgBox .cont .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    margin-right: 30px;
  }

  .msgBox .cont .write-text{
    display: inline-block;
    vertical-align: top;
  }

  .msgBox .cont>>> .el-input--suffix .el-input__inner{
    width: 300px;
  }

  .msgBox .btnBox{
    margin-top: 30px;
  }

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.write-txt>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-txt>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.reviewBox .write-text input,
.write-txt>>> .el-radio-group{
  display: inline-block;
  vertical-align: middle;
}

.write-txt .title{
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
}

.write-txt .btn-topic-ai,
.write-txt .btn-topic-remove{
  color: #fff;
  font-size: 18px;
  background-color: #F26060;
  border-radius: 6px;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  box-sizing: border-box;
  padding: 0px 36px;
}

.MobelBox .write-text .btn.btn-topic-ai{
  background-color: #00C7A3;
  color: #fff;
}

.write-txt .btn-topic-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  border: solid 1px #00C7A3;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  box-sizing: border-box;
  padding: 0px 24px;
}

.reviewBox .write-text input{
  margin-right: 20px;
}

.btn-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  padding: 6px 24px;
  box-sizing: border-box;
  display: block;
  margin-top: 37px;
  border: solid 1px #00C7A3;
}

.content-item{
  display: block;
  margin-bottom: 70px;
}

.write-setup{
  margin-top: 30px;
}

.write-setup .write-text p{
  color: #777777;
  font-size: 12px;
  display: inline-block;
  line-height: 39px;
  height: 39px;
  vertical-align: top;
  margin-left: 20px;
}

.MobelBox .write-text .btn.btn-setup{
  font-size: 16px;
  color: #fff;
  background-color: #00C7A3;
  border-radius: 6px;
  box-sizing: border-box;
  position: relative;
  height: 39px;
  line-height: 39px;
}

.backBox .btn-choose{
  background-color: #00C7A3;
  border-radius: 8px;
  color: #fff;
  font-size: 22px;
  box-sizing: border-box;
  padding: 10px 24px;
  float: right;
}

.word-item{
  border-bottom: 2px dashed #AAAAAA;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/resource/exam.vue